/* eslint-disable no-multi-assign */
import * as WXS from './wxs';
import * as ALIPAY from './alipay';
import Configs from '../../../../config';

const userAgent = window.navigator.userAgent;

export const isAlipay = window.isAlipay = userAgent.match(/AliApp/);
export const isWechat = window.isWechat = userAgent.match(/MicroMessenger/);
export const isMobile = window.isMobile = userAgent.match(/Mobile/);

export const ClientType = isAlipay ? 'ALIPAY' : isWechat ? 'WECHAT' : 'BROWSER';

const promisify = (method) => (options) => {
  return new Promise((rec, rej) => {
    method({
      ...options,
      success: (res) => {
        rec(res);
      },
      error: (err) => {
        rej(err);
      }
    });
  });
};

export const config = () => {
  if (isWechat) {
    return WXS.config(Configs.wxs);
  }
  return ALIPAY.config(Configs.alipay);
};

export const init = (...options) => {
  if (isWechat) {
    return WXS.init(...options);
  }
  return Promise.resolve();
};

export const openid = (...options) => {
  if (isWechat) {
    return WXS.openid(...options);
  }
  if (isMobile && !isAlipay && process.env.NODE_ENV === 'online') {
    return Promise.reject('暂不支持原生浏览器登录,请在微信/支付宝中打开');
  }
  return ALIPAY.openid(...options);
};

let locationCache = undefined;

export const getLocation = async () => {
  if(locationCache) {
    return locationCache;
  }

  locationCache = WXS.init().then(() => {
    if (isAlipay) {
      return ALIPAY.getLocation();
    }
    if (isWechat) {
      return promisify(WXS.Wechat.getLocation)();
    }
    return Promise.reject();
  }).catch((e) => {
    if (window.navigator.geolocation) {
      return new Promise((rec, rej) => {
        window.navigator.geolocation.getCurrentPosition((position) => {
          rec({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude
          });
        }, (e) => {
          console.log(e);
          rej('定位服务不可用');
        }, {
          timeout: 1000
        });
      });
    }
    return Promise.reject(e || '定位服务不可用');
  });

  return locationCache;
};

export const openLocation = ({ longitude, latitude, name, address }) => {
  if (isAlipay) {
    return ALIPAY.openLocation({
      longitude,
      latitude,
      name,
      address
    });
  }
  if (isWechat) {
    return WXS.Wechat.openLocation({
      longitude,
      latitude,
      name,
      address,
      scale: 15
    });
  }
  alert('暂不支持,请用支付宝/微信打开');
  return '';
};

export const scan = () => {
  if (isWechat) {
    return new Promise((rec, rej) => {
      WXS.Wechat.scanQRCode({
        needResult: 1,
        scanType: ['qrCode'],
        success: (res) => {
          rec(res.resultStr);
        },
        error: (err) => {
          rej(err);
        }
      });
    });
  }
  if (isAlipay) {
    return ALIPAY.scan();
  }
  return Promise.reject('暂不支持, 请在微信/支付宝中打开');
};
